import call from "./call";

export const fetchFilteredContent = async (
  entity_type: string,
  entity_id: string,
  question_list_id: string | number
) => {
  const response = await call.get<Blob>(
    `/v2/filtered_content/${entity_type}/${entity_id}/?question_list_id=${question_list_id}`,
    {
      responseType: "blob",
      snack: {
        error: "filteredcontent.downloadError",
      },
    }
  );
  return response;
};
